import { render, staticRenderFns } from "./PlatformShippingMethods.vue?vue&type=template&id=51fc7ddf"
import script from "./PlatformShippingMethods.vue?vue&type=script&lang=js"
export * from "./PlatformShippingMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports